// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MdmTable-makeMdmActionColumn-module__actionCell--jG2_X {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
}
/*# sourceMappingURL=makeMdmActionColumn.module.css.map */`, "",{"version":3,"sources":["webpack://./makeMdmActionColumn.module.less","webpack://./src/components/MdmTable/makeMdmActionColumn.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;ACCF;AACA,yDAAyD","sourcesContent":[".actionCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n",".actionCell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n}\n/*# sourceMappingURL=makeMdmActionColumn.module.css.map */"],"sourceRoot":""}]);
// Exports
export var actionCell = `src-components-MdmTable-makeMdmActionColumn-module__actionCell--jG2_X`;
export default ___CSS_LOADER_EXPORT___;
